import { useState } from "react";
import { toast } from "sonner";
import { BellRing, Mail, Sunrise, CalendarRange, DatabaseBackup, Sparkles, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Block } from "./Common";
import PanelBackups from "./PanelBackups";

const JOBS = [
  ["pre", "Kirim pengingat sebelum batas sekarang", BellRing],
  ["daily", "Kirim rekap ke Leader sekarang", Mail],
  ["morning", "Kirim pengingat ke anggota sekarang", Sunrise],
  ["weekly", "Kirim rekap mingguan sekarang", CalendarRange],
  ["backup", "Backup sekarang", DatabaseBackup],
];

const describe = (r) => {
  if (r.slot === "backup") return `Backup tersimpan: ${r.file}`;
  if (r.slot === "weekly") return `Rekap mingguan dikirim ke ${r.count} penerima`;
  if (r.slot === "daily") return `Rekap dikirim ke ${r.count} penerima (${r.filled}/${r.due} sudah mengisi)`;
  return `${r.count} anggota diingatkan`;
};

export default function PanelJobs({ onRestored }) {
  const [busy, setBusy] = useState("");
  const [last, setLast] = useState("");
  const [backupVersion, setBackupVersion] = useState(0);
  const run = async (name) => {
    setBusy(name);
    try {
      const r = await api.post(`/jobs/${name}/run`);
      const msg = describe(r.data);
      setLast(msg);
      toast.success(msg);
      if (name === "backup") setBackupVersion((v) => v + 1);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  const demo = async (kind) => {
    setBusy(kind);
    try {
      const r = await api.post(`/demo/${kind}`);
      toast.success(kind === "seed" ? `Data contoh ditambahkan (${r.data.reports} laporan)` : "Data contoh dihapus");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <Block title="Kirim & backup manual" testid="panel-jobs">
      <div className="flex flex-col gap-2">
        {JOBS.map(([k, l, Icon]) => (
          <button key={k} data-testid={`job-run-${k}`} disabled={!!busy} onClick={() => run(k)} className="btn-ghost justify-start">
            <Icon size={16} className="text-brand" /> {busy === k ? "Memproses…" : l}
          </button>
        ))}
      </div>
      {last && <p data-testid="job-last-result" className="mt-3 rounded-xl bg-brand-soft p-3 text-sm font-semibold">{last}</p>}
      <PanelBackups version={backupVersion} onRestored={onRestored} />
      <div className="mt-5 border-t border-brand-line pt-4">
        <span className="label">Data contoh</span>
        <div className="flex flex-wrap gap-2">
          <button data-testid="demo-seed-button" disabled={!!busy} onClick={() => demo("seed")} className="btn-soft"><Sparkles size={15} /> Isi data contoh</button>
          <button data-testid="demo-clear-button" disabled={!!busy} onClick={() => demo("clear")} className="btn-ghost"><Trash2 size={15} /> Hapus data contoh</button>
        </div>
      </div>
    </Block>
  );
}
